var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemovePreImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5428_14591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88245 6.98294C5.57712 6.98294 6.95093 5.65345 6.95093 4.01344C6.95093 2.37344 5.57712 1.04395 3.88245 1.04395C2.18777 1.04395 0.813965 2.37344 0.813965 4.01344C0.813965 5.65345 2.18777 6.98294 3.88245 6.98294Z",
    fill: "white",
    stroke: "#EDE7E4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.803 3.12256L2.96191 4.90426",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96191 3.12256L4.803 4.90426",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5428_14591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.36436,
    height: 7.1268,
    fill: "white",
    transform: "translate(0.200195 0.449951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePreImg);
export default __webpack_public_path__ + "static/media/remove-pre-img.fa001aa9837f1aa7bd23f52ab7cfa1cc.svg";
export { ForwardRef as ReactComponent };